import _toConsumableArray from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useState } from "react";
import useDebounce from "components/common/utils/useDebounce";
import useNotify from "services/notification";
import { generateID } from "../../tools";
import Fields from "./Fields";
import Styles from "./Styles.module.scss";
import Options from "../../shared-components/Options";
import Head from "../../shared-components/Head";
import Date from "../../shared-components/Tabs/Date";
var initial = [{
  id: "first"
}];
var maximum = 12;
function Bar(_ref) {
  var getContext = _ref.getContext;
  var Notify = useNotify();
  var _getContext = getContext(),
    state = _getContext.state,
    setState = _getContext.setState;
  var _state$searchFields = state.searchFields,
    searchFields = _state$searchFields === void 0 ? initial : _state$searchFields;
  var _useState = useState(searchFields.map(function (field) {
      return _objectSpread({}, field);
    })),
    fields = _useState[0],
    setFields = _useState[1];
  var _useState2 = useState(false),
    toggleYearState = _useState2[0],
    setToggleYearState = _useState2[1];
  var handleAddField = useCallback(function () {
    if (fields.length === maximum) {
      Notify.warning({
        text: "You have reached maximum 12 search fields."
      });
      return;
    }
    setFields([].concat(_toConsumableArray(fields), [{
      id: generateID()
    }]));
  }, [fields]);
  var handleSetField = useCallback(function (field) {
    return function (key, value) {
      // eslint-disable-next-line no-param-reassign
      field[key] = value;
      setFields(function (prev) {
        return _toConsumableArray(prev);
      });
    };
  }, [setFields]);
  var handleDeleteField = useCallback(function (field) {
    return function () {
      var set = new Set(fields);
      set["delete"](field);
      setFields(_toConsumableArray(Array.from(set)));
    };
  }, [fields]);
  var debouncedSearch = useDebounce(function () {
    setState({
      searchFields: fields.map(function (field) {
        return _objectSpread({}, field);
      })
    });
  }, 200, [fields]);
  var handleSubmit = useCallback(function (e) {
    e.preventDefault();
    var disableSubmit = fields.some(function (_ref2) {
      var search = _ref2.search;
      return !(search !== null && search !== void 0 && search.length) || (search === null || search === void 0 ? void 0 : search.length) < 1;
    });
    if (!disableSubmit) debouncedSearch();
  }, [fields]);

  // Show and Hide the year range row
  var toggleYearRange = function toggleYearRange() {
    setToggleYearState(!toggleYearState);
  };
  return /*#__PURE__*/React.createElement("form", {
    className: Styles.bar,
    onSubmit: handleSubmit,
    name: "search-form"
  }, /*#__PURE__*/React.createElement(Head, {
    help: false,
    title: "Discover the highest-quality engineering content,",
    text: " data, and intelligence"
  }), fields.map(function (field, index) {
    return /*#__PURE__*/React.createElement(Fields, {
      key: field.id,
      first: index === 0,
      last: index === fields.length - 1,
      field: field,
      row: index + 1,
      setField: handleSetField(field),
      deleteField: handleDeleteField(field)
    });
  }), /*#__PURE__*/React.createElement(Date, {
    toggleYearState: toggleYearState,
    toggleYearRow: toggleYearRange
  }), /*#__PURE__*/React.createElement(Options, {
    onAdd: handleAddField,
    toggleYearRow: toggleYearRange,
    toggleYearState: toggleYearState
  }));
}
export default Bar;